import PersianSupportNumericTextField from 'Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField';
import SingleReactHookFormWrapper from 'Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper';
import React from 'react';
import i18next from 'i18next';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { useContext } from 'react';

const MobileNumberInput = ({ control, formState }) => {
  const languageArray =
    useContext(GlobalContext)?.LanguageArray;

  return (
    <React.Fragment>
      <SingleReactHookFormWrapper
        element={
          <PersianSupportNumericTextField
            isOctalAllowed={true}
            label={FindLangKey(
              'login-input-telephone-number',
              languageArray
            )}
            isEnglish={i18next?.language === 'en'}
          />
        }
        control={control}
        errors={formState.errors}
        name="Mobile"
        isPassword={false}
        required={false}
      />
    </React.Fragment>
  );
};

export default MobileNumberInput;
